<template>
	<v-container>
		<v-row >
			<v-col>
			  <v-data-table
			    :headers="headers"
			    :items="direcciones"
			    sort-by="calories"
			    class="elevation-0"

			    >
			    <template v-slot:top>
			      <v-toolbar flat color="white">
			        <v-toolbar-title>Mis Direciones</v-toolbar-title>
			        <v-divider
			          class="mx-4"
			          inset
			          vertical
			        ></v-divider>
			        <v-spacer></v-spacer>
			        <v-dialog v-model="dialog" max-width="500px">
			          <template v-slot:activator="{ on }">
			            <v-btn color="primary" dark class="mb-2" v-on="on" @click="modo=1">Agregar</v-btn>
			          </template>
			          <v-card>
			            <v-card-title>
			              <span class="headline">Dirección de envío</span>
			            </v-card-title>

			            <v-card-text>
			              <v-container>
			                <v-row>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.nomdir" label="Nombre"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.calle" label="Calle"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.numint" label="Num int"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.numext" label="Num ext"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.colonia" label="Colonia"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.ciudad" label="Ciudad"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.estado" label="estado"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field v-model="editedItem.cp" label="cp"></v-text-field>
			                  </v-col>
			                </v-row>
			              </v-container>
			            </v-card-text>

			            <v-card-actions>
			              <v-spacer></v-spacer>
			              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
			              <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
			            </v-card-actions>
			          </v-card>
			        </v-dialog>
			      </v-toolbar>
			    </template>

			    <template v-slot:item.estatus="{ item }">
			      <v-checkbox label="Principal" v-model="item.estatus==1?true:false " dense></v-checkbox>
			    </template>

			    <template v-slot:item.actions="{ item }">
			      <v-icon
			        small
			        class="mr-2"
			        @click="editItem(item)"
			        color="primary"
			      >
			        mdi-pencil
			      </v-icon>
			      <v-icon
			        small
			        @click="deleteItem(item)"
			        color="secondary"
			      >
			        mdi-delete
			      </v-icon>
			    </template>
			    <template v-slot:no-data>
			      <v-btn color="primary" @click="initialize">Reset</v-btn>
			    </template>
			  </v-data-table>
			</v-col>
		</v-row>

	  <!-- Eliminar -->
	  <v-dialog v-model="eliminar" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Dirección de envío</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col >
                <v-card class="elevation-0">
                	<v-card-title primary-title>
                	  ¿Deseas eliminar esta dirección de envío?
                	</v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="eliminar = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="deleteDireccion()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</v-container>
</template>

<script>
	import {mapGetters} from 'vuex'
  export default {
    data: () => ({
    	eliminar: false,
    	idEliminar:0,

    	modo:1, // 1 = nuevo, 2 = editar
      dialog: false,
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'nomdir',
        },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      direcciones: [],
      editedIndex: -1,
      editedItem: {
        nomdir:'',
        iddirecciones:0,
				calle:'',
				numint:0,
				numext:0,
				colonia:'',
				ciudad:'',
				estado:'',
				cp:''
      },
      defaultItem: {
        nomdir:'',
        iddirecciones:0,
				calle:'',
				numint:0,
				numext:0,
				colonia:'',
				ciudad:'',
				estado:'',
				cp:''
      },
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
      	this.$http.get('direcciones.usuario/' + this.getdatosUsuario.idusuariosweb).then(response=>{
      		this.direcciones = response.body
      	}).catch(error=>{console.log(error)})
        
      },

      editItem (item) {
      	this.modo = 2
        // this.editedIndex = this.direcciones.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        this.editedItem = item
        this.dialog = true
      },

      deleteItem (item) {
        this.eliminar = true
        this.idEliminar = item.iddirecciones
      },

      deleteDireccion(){
      	this.$http.delete('direcciones.delete/' + this.idEliminar).then(response=>{
      		this.eliminar = false
      		this.initialize()
      	}).catch(error=>{console.log(error)})
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	var payload = {
      		iddirecciones:  this.editedItem.iddirecciones,
      		nomdir:        this.editedItem.nomdir,
      		calle:         this.editedItem.calle,
      		numint:        this.editedItem.numint,
      		numext:        this.editedItem.numext,
      		colonia:       this.editedItem.colonia,
      		ciudad:        this.editedItem.ciudad,
      		estado:        this.editedItem.estado,
      		cp:            this.editedItem.cp,
      		idusuariosweb: this.getdatosUsuario.idusuariosweb
      	}
      	console.log(payload)
        if (this.modo == 2) {
          this.$http.put('direcciones.update',payload).then(response=>{
	      		this.initialize()
	      	}).catch(error=>{console.log(error)})
        } else {
	        this.$http.post('direcciones.add',payload).then(response=>{
	      		this.initialize()
	      	}).catch(error=>{console.log(error)})
        }
        this.close()
      },
    },

    computed:{
    	...mapGetters('login',['getdatosUsuario'])
    }
  }
</script>